import CloseIcon from "@mui/icons-material/Close";
import { Z_INDEX } from "constants/constants";
import { CollapseIcon, Header } from "./FlightDebuggerStyles";
import { useDebuggerPopupState } from "./debuggerUtils";
import { useCallback } from "react";
import useWindowSize from "utils/customHooks/useWindowSize";

export function PopupHeader({ isTouchDevice, bindDragHandler, networkName }) {
  const [{ collapsed }, setDebuggerPopupState] = useDebuggerPopupState();
  const handleClosePopup = useCallback(() => {
    setDebuggerPopupState(prev => ({
      ...prev,
      popupData: null,
      isPreview: false,
      isPopupOpen: false,
    }));
  }, [setDebuggerPopupState]);
  const { innerWidth } = useWindowSize();
  return (
    <Header
      style={{
        width: "100%",
        boxSizing: "border-box",
      }}
      data-collapsed={collapsed}
    >
      <div
        className="dragArea"
        {...(isTouchDevice && innerWidth < 600 ? {} : bindDragHandler())}
        onDoubleClick={() => {
          setDebuggerPopupState(prev => ({
            ...prev,
            isPreview: !prev.isPreview,
          }));
        }}
      >
        {networkName}
      </div>
      <CollapseIcon
        style={{ zIndex: Z_INDEX.L11 }}
        $collapsed={collapsed}
        onClick={() =>
          setDebuggerPopupState(prev => ({
            ...prev,
            collapsed: !prev.collapsed,
          }))
        }
      />
      <CloseIcon
        style={{ zIndex: Z_INDEX.L11 }}
        onTouchStart={handleClosePopup}
        onClick={handleClosePopup}
      />
    </Header>
  );
}
